import type { ReactNode } from 'react';
import BirdIconSvg from './icons/BirdIconSvg';
import { getBirdIconDef } from './icons/registry';
import usePrefersReducedMotion from '../../hooks/usePrefersReducedMotion';

type EmptyStateProps = {
  title: string;
  description: string;
  /** Heroicon component or any React node */
  icon?: ReactNode;
  /** Registry key e.g. "DocumentTextIcon" — uses animated bird SVG when set */
  iconName?: string;
  action?: ReactNode;
  className?: string;
};

export default function EmptyState({
  title,
  description,
  icon,
  iconName,
  action,
  className = '',
}: EmptyStateProps) {
  const reducedMotion = usePrefersReducedMotion();
  const registryIcon = iconName ? (
    <BirdIconSvg
      def={getBirdIconDef(iconName)}
      className={`h-10 w-10 text-cyan-600 ${reducedMotion ? '' : 'animate-[float_5s_ease-in-out_infinite]'}`}
      animated={!reducedMotion}
    />
  ) : null;

  const displayIcon = registryIcon ?? icon;

  return (
    <div className={`glass-panel interactive-card mt-8 rounded-2xl p-8 text-center ${className}`}>
      {displayIcon ? (
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-cyan-50 to-violet-50 text-slate-600 shadow-inner">
          {displayIcon}
        </div>
      ) : null}
      <h3 className="mt-4 text-base font-semibold text-slate-900">{title}</h3>
      <p className="mx-auto mt-2 max-w-xl text-sm text-slate-600">{description}</p>
      {action ? <div className="mt-6 flex justify-center">{action}</div> : null}
    </div>
  );
}
